export const API_URL = "/api";
export const WEBHOOK_URL = "https://webhook.$HOSTNAME:$PORT";
export const API_VERSION = "1";